module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Oberdorf_BL-b2f0d719571ad3cb825dffde49e8a20e.svg";